export const DRAFT_MAX_WIDTH = 627;

export const STATS_MAX_WIDTH = 400;

export const POSTS_LIMIT = 20;

export const TITLE = 'Продвижение контента';

export const MIN_WEEKLY_LIMIT_VALUE = 300;
